import { PatientGroup } from '@dreryk/egabinet-patient-frontend-api';

import { createSingleInterpolatedTranslationKey, TranslatableText, useTranslate } from '@dreryk/react-common';

import { appointmentsTranslationKeys } from '../../../translations';

const FILTER_SEPARATOR = ', ';

export const usePatientGroupsFilterLabel = (
   selectedPatientGroupIds: number[],
   patientGroups: PatientGroup[]
): TranslatableText => {
   const translate = useTranslate();

   if (selectedPatientGroupIds.length === patientGroups.length) {
      return createSingleInterpolatedTranslationKey(
         appointmentsTranslationKeys.patientGroupFilter.filterLabel,
         'patientGroups',
         translate(appointmentsTranslationKeys.patientGroupFilter.filterLabelAll)
      );
   }

   const patientGroupById = Object.fromEntries(patientGroups.map(({ id, name }) => [id, name]));

   return createSingleInterpolatedTranslationKey(
      appointmentsTranslationKeys.patientGroupFilter.filterLabel,
      'patientGroups',
      selectedPatientGroupIds
         .map((id) => patientGroupById[Number(id)])
         .filter(Boolean)
         .join(FILTER_SEPARATOR)
   );
};
